import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material';

import { DbmTimeframeComponent } from './dbm-timeframe.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BrowserAnimationsModule,
        MatSelectModule
    ],
    declarations: [DbmTimeframeComponent],
    entryComponents: [DbmTimeframeComponent],
    exports: [DbmTimeframeComponent]
})
export class DbmTimeframeModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-timeframe/dbm-timeframe.module.ts